import {AfterContentChecked, Component, Input, OnInit} from "@angular/core";
import {User} from "../../../../core/models/user";
import {IntegrationInvite} from "../../../../core/models/integrationInvite";
import * as moment from "moment-timezone";

@Component({
  selector: 'int-integrators-details',
  templateUrl: './integrator-details.component.html',
  styleUrls: ['./integrator-details.component.scss']
})
export class IntegratorDetailsComponent implements AfterContentChecked {
  @Input() user: User
  @Input() invites: any[];
  @Input() creating: boolean;
  @Input() integrationName: string;
  @Input() integrationType: string;
  currentInvite: IntegrationInvite;

  constructor() {}

  ngAfterContentChecked() {
    this.currentInvite = this.invites ?
        this.invites.find(i => i.integrations.includes(this.integrationType)) : undefined;
  }

  getIntName() {

  }

  formatDate(date) {
    return moment(date).format('MMMM DD, YYYY')
  }

}